import { Location } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-no-route',
  templateUrl: './no-route.component.html',
})
export class NoRouteComponent {
  constructor(protected _location: Location) { }
}
